(function(){
  const root = document.querySelector('.nektr-pdp-v9-9');
  if (!root) return;

  // ---------- Gallery (Apr-24 PM rev 2: flavor click SELECTS a thumb; all thumbs always visible) ----------
  const thumbs = root.querySelectorAll('.thumb');
  const galMain = root.querySelector('#gal-main');
  const galBadge = root.querySelector('#gal-badge');

  function selectThumb(t) {
    if (!t) return;
    thumbs.forEach(x => x.classList.remove('on'));
    t.classList.add('on');
    galMain.src = t.dataset.src;
    // Auto-hide the rotating badge on images that already have text at the top
    if (galBadge) {
      galBadge.hidden = (t.dataset.noBadge === 'true');
    }
    // Scroll the selected thumb into view on mobile (horizontal carousel)
    const thumbsContainer = root.querySelector('#thumbs');
    if (thumbsContainer && window.innerWidth <= 720) {
      t.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
    }
  }

  thumbs.forEach(t => {
    t.addEventListener('click', () => selectThumb(t));
  });

  // ---------- Flavor (selects the hero thumb for that flavor; no hiding) ----------
  const flavorBtns = root.querySelectorAll('.flavor-btn');
  const flavorMeta = root.querySelector('#flavor-meta');

  flavorBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      flavorBtns.forEach(b => b.classList.remove('on'));
      btn.classList.add('on');
      const flavor = btn.dataset.flavor;
      if (flavorMeta) flavorMeta.textContent = btn.querySelector('.name').textContent;
      // Find the "hero" thumb flagged for this flavor and select it
      const heroForFlavor = root.querySelector(`.thumb[data-hero-for-flavor="${flavor}"]`);
      if (heroForFlavor) selectThumb(heroForFlavor);
    });
  });

  // Init: sync the badge state for the initial "on" thumb
  const initialOn = root.querySelector('.thumb.on');
  if (initialOn && galBadge) galBadge.hidden = (initialOn.dataset.noBadge === 'true');

  // ---------- Debug logging (gate behind window.NEKTR_DEBUG=true to silence in prod) ----------
  const DEBUG = (typeof window !== 'undefined' && window.NEKTR_DEBUG === true);
  function dlog() { if (DEBUG) console.log.apply(console, ['[NEKTR PDP]'].concat([].slice.call(arguments))); }
  function dwarn() { if (DEBUG) console.warn.apply(console, ['[NEKTR PDP]'].concat([].slice.call(arguments))); }

  // ---------- Product data + per-variant lookup ----------
  // pdpData.variants is keyed by variant ID and contains: id, title, available,
  // price (cents), compareAtPrice, subscribeAvailable, subscribeFirstPrice (cents),
  // subscribeRefillPrice (cents). All derived server-side from
  // product.variants[].selling_plan_allocations — NOT hardcoded percentages.
  const pdpDataEl = document.getElementById('nektr-pdp-data');
  let pdpData = null;
  try { pdpData = pdpDataEl ? JSON.parse(pdpDataEl.textContent) : null; }
  catch (e) { dwarn('failed to parse pdpData', e); }

  function getCurrentVariantId() {
    const activeFlavorBtn = root.querySelector('.flavor-btn.on');
    if (activeFlavorBtn && activeFlavorBtn.dataset.variantId) return activeFlavorBtn.dataset.variantId;
    if (!pdpData) return null;
    const flavorKey = activeFlavorBtn ? activeFlavorBtn.dataset.flavor : 'unflav';
    return flavorKey === 'vanilla' ? pdpData.variantVanilla : pdpData.variantUnflav;
  }
  function getCurrentVariant() {
    if (!pdpData || !pdpData.variants) return null;
    const id = getCurrentVariantId();
    return id ? (pdpData.variants[String(id)] || null) : null;
  }
  function getSubscribe() {
    const subBtn = root.querySelector('.purchase-opt.sub');
    return !!(subBtn && subBtn.classList.contains('on'));
  }

  let qty = 1;

  const qtyVal = root.querySelector('#qty-val');
  const qtyMeta = root.querySelector('#qty-meta');
  const qtyMinus = root.querySelector('#qty-minus');
  const qtyPlus = root.querySelector('#qty-plus');
  const subPrice = root.querySelector('#sub-price');
  const subStrike = root.querySelector('#sub-strike');
  const subPerServing = root.querySelector('#sub-per-serving');
  const onePrice = root.querySelector('#one-price');
  const atcTotal = root.querySelector('#atc-total');
  const saveBadge = root.querySelector('#save-badge');
  const shopPay = root.querySelector('#shop-pay');
  const smPrice = root.querySelector('#sm-price') || document.getElementById('sm-price');
  const finalCtaPrice = document.getElementById('final-cta-price');
  const purchaseOpts = root.querySelectorAll('.purchase-opt');
  const subOpt = root.querySelector('.purchase-opt.sub');
  const oneOpt = root.querySelector('.purchase-opt.one');

  // Hide Subscribe entirely only if NO variant has a subscribe plan attached.
  // (We use per-variant subscribePlanId so each variant can have its own plan,
  // and this check tolerates mixed setups where some variants are eligible.)
  function anyVariantSubscribable() {
    if (!pdpData || !pdpData.variants) return false;
    const ids = Object.keys(pdpData.variants);
    for (let i = 0; i < ids.length; i++) {
      if (pdpData.variants[ids[i]].subscribePlanId) return true;
    }
    return false;
  }
  if (!pdpData || !anyVariantSubscribable()) {
    if (subOpt) subOpt.style.display = 'none';
    if (oneOpt) {
      purchaseOpts.forEach(o => o.classList.remove('on'));
      oneOpt.classList.add('on');
      const inner = oneOpt.querySelector('.radio-inner');
      if (inner) inner.style.display = 'block';
    }
  }

  function render() {
    const subscribe = getSubscribe();
    const variant = getCurrentVariant();
    qtyVal.textContent = qty;
    if (qty > 1) {
      qtyMeta.hidden = false;
      qtyMeta.textContent = `${qty} jars · ${qty * 40} servings · ~${qty} months of daily use`;
    } else {
      qtyMeta.hidden = true;
    }
    qtyMinus.disabled = qty <= 1;
    if (qtyPlus) qtyPlus.disabled = qty >= 12;

    // Pricing reads from per-variant data (which itself comes from
    // selling_plan_allocations server-side). Falls back to one-time price
    // if subscribe pricing isn't available for the selected variant.
    const variantPriceCents = variant ? variant.price : 6800;
    const subscribeFirstCents = (variant && variant.subscribeFirstPrice != null) ? variant.subscribeFirstPrice : Math.round(variantPriceCents * 0.70);
    const subTotal = (subscribeFirstCents / 100) * qty;
    const oneTotal = (variantPriceCents / 100) * qty;
    subPrice.textContent = '$' + subTotal.toFixed(2);
    subStrike.textContent = '$' + oneTotal.toFixed(2);
    if (subPerServing) {
      subPerServing.textContent = '$' + ((subscribeFirstCents / 100 / 40)).toFixed(2) + ' / serving';
    }
    onePrice.textContent = '$' + oneTotal.toFixed(2);

    // Per-variant subscribe eligibility — if current variant doesn't have
    // a selling plan attached, gray out the Subscribe option (CSS handles
    // visual). Auto-switch to OTP if user had Subscribe selected.
    const subscribeAvailable = !!(variant && variant.subscribeAvailable);
    if (subOpt) {
      if (pdpData && pdpData.subscribePlanId) {
        subOpt.classList.toggle('disabled', !subscribeAvailable);
        subOpt.setAttribute('aria-disabled', subscribeAvailable ? 'false' : 'true');
        if (subscribe && !subscribeAvailable) {
          // Auto-switch: subscribe was selected but isn't valid for this variant.
          subOpt.classList.remove('on');
          const subInner = subOpt.querySelector('.radio-inner');
          if (subInner) subInner.style.display = 'none';
          if (oneOpt) {
            oneOpt.classList.add('on');
            const oneInner = oneOpt.querySelector('.radio-inner');
            if (oneInner) oneInner.style.display = 'block';
          }
          dlog('auto-switched to OTP — subscribe unavailable for variant', variant && variant.title);
        }
      }
    }

    // Re-derive subscribe in case we just auto-switched.
    const subscribeNow = getSubscribe();
    const activeTotal = subscribeNow ? subTotal : oneTotal;
    const activeStr = '$' + activeTotal.toFixed(2);
    // Re-query #atc-total LIVE because addToCart's success path replaces
    // labelEl.innerHTML (with "Adding…" then restored originalLabel), which
    // destroys the original #atc-total span and creates a new one. The cached
    // atcTotal reference points to a detached node after the first ATC.
    const liveAtcTotal = root.querySelector('#atc-total') || atcTotal;
    if (liveAtcTotal) liveAtcTotal.textContent = activeStr;
    if (saveBadge) saveBadge.style.display = subscribeNow ? 'inline-block' : 'none';
    if (shopPay) shopPay.textContent = '$' + (activeTotal / 4).toFixed(2);
    if (smPrice) smPrice.textContent = activeStr;
    if (finalCtaPrice) finalCtaPrice.textContent = activeStr;

    // Sold-out gate on ATC + sticky/final
    const available = !variant || variant.available !== false;
    [atcBtnEl(), document.getElementById('final-cta-btn'), document.querySelector('.sticky-mobile .sm-btn')].forEach(b => {
      if (!b) return;
      if (!available) {
        b.disabled = true;
        b.dataset.soldout = 'true';
        const lbl = b.querySelector('.atc-label') || b;
        if (b.id === 'atc-btn' && lbl) lbl.textContent = 'Sold out';
      } else if (b.dataset.soldout === 'true') {
        b.disabled = false;
        delete b.dataset.soldout;
      }
    });

    dlog('render', { subscribe: subscribeNow, variantId: variant && variant.id, activeTotal });
  }

  function atcBtnEl() { return document.getElementById('atc-btn'); }

  // qty/purchase handlers update DOM/state only — the rendering (and form
  // sync + URL update) happens via syncAll, which is wired below as a
  // separate listener that fires AFTER these. One render per click, no dupes.
  qtyMinus.addEventListener('click', () => { if (qty > 1) qty--; });
  qtyPlus.addEventListener('click', () => { if (qty < 12) qty++; });

  purchaseOpts.forEach(opt => {
    opt.addEventListener('click', () => {
      // Re-click on the already-active option = no-op (avoids duplicate
      // change events Appstle would re-handle).
      if (opt.classList.contains('on')) return;
      // Block clicks on the subscribe option if it's disabled for the
      // currently-selected variant.
      if (opt.classList.contains('sub') && opt.classList.contains('disabled')) {
        dlog('subscribe option click ignored — disabled for current variant');
        return;
      }
      purchaseOpts.forEach(o => {
        o.classList.remove('on');
        const inner = o.querySelector('.radio-inner');
        if (inner) inner.style.display = 'none';
      });
      opt.classList.add('on');
      const inner = opt.querySelector('.radio-inner');
      if (inner) inner.style.display = 'block';
      dlog('purchase-opt clicked:', opt.dataset.purchase);
    });
  });

  // ---------- Shopify cart wiring (Ajax /cart/add.js + Impulse cart drawer events) ----------
  // pdpData was already parsed at the top of this IIFE (above render()).
  const variantInput = document.getElementById('nektr-pdp-variant-id');
  const quantityInput = document.getElementById('nektr-pdp-quantity');
  const sellingPlanInput = document.getElementById('nektr-pdp-selling-plan');
  const addForm = document.getElementById('nektr-pdp-add-form');

  // Sync Appstle's own radio inputs to match our UI state. Appstle injects
  // two `<input name="selling_plan">` radios inside #appstle_subscription_widget0
  // (one per option: Subscribe with the plan ID as value, OTP with empty value).
  // Appstle's fetch interceptor reads from THESE radios, not from our hidden
  // input — so without syncing them, the interceptor always sends whatever
  // its widget shows as selected (default: Subscribe), forcing every cart-add
  // to be a subscription regardless of what our UI says. This sync fixes that.
  function syncAppstleRadios(subscribe) {
    const appstleRadios = document.querySelectorAll('#appstle_subscription_widget0 input[name="selling_plan"], [id^="shopify-block-"][id*="appstle_subscription"] input[name="selling_plan"]');
    if (!appstleRadios.length) return;
    appstleRadios.forEach(r => {
      // value is non-empty for Subscribe, empty for OTP
      const isSubRadio = !!r.value;
      const shouldCheck = subscribe ? isSubRadio : !isSubRadio;
      if (shouldCheck && !r.checked) {
        r.checked = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
        r.dispatchEvent(new Event('click', { bubbles: true }));
      } else if (!shouldCheck && r.checked) {
        r.checked = false;
      }
    });
  }

  function syncHiddenInputs() {
    if (!variantInput || !pdpData) return;
    const subscribe = getSubscribe();
    const variantId = getCurrentVariantId();
    const variant = getCurrentVariant();
    variantInput.value = variantId || '';
    if (quantityInput) quantityInput.value = qty;
    // Per-variant selling_plan: each variant carries its OWN subscribePlanId
    // (from its first selling_plan_allocation). Sends the variant's actual
    // plan, not a global one — defends against mixed-plan setups.
    const variantPlanId = variant && variant.subscribePlanId ? variant.subscribePlanId : null;
    const planEligible = !!(variant && variant.subscribeAvailable && variantPlanId);
    if (sellingPlanInput) {
      sellingPlanInput.value = (subscribe && planEligible) ? variantPlanId : '';
      sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    window.appstleSelectedSellingPlan = sellingPlanInput && sellingPlanInput.value ? sellingPlanInput.value : undefined;
    // Tell Appstle's widget the user's choice so its interceptor sends correctly.
    syncAppstleRadios(subscribe && planEligible);
    dlog('syncHiddenInputs', { subscribe, variantId, qty, selling_plan: sellingPlanInput && sellingPlanInput.value, planEligible, variantPlanId });
  }

  // ---------- URL state (replaceState ?variant=X&selling_plan=Y) ----------
  // Mirrors Impulse's native PDP behavior so back-button, share, refresh
  // restore the user's selection. NEVER use pushState — back button shouldn't
  // hop variants. (Dawn 2026 canonical pattern.)
  function updateUrlState() {
    if (typeof window.history.replaceState !== 'function') return;
    const variantId = getCurrentVariantId();
    const subscribe = getSubscribe();
    const variant = getCurrentVariant();
    const variantPlanId = variant && variant.subscribePlanId ? variant.subscribePlanId : null;
    const planEligible = !!(variant && variant.subscribeAvailable && variantPlanId);
    try {
      const url = new URL(window.location.href);
      if (variantId) url.searchParams.set('variant', String(variantId)); else url.searchParams.delete('variant');
      if (subscribe && planEligible) url.searchParams.set('selling_plan', String(variantPlanId));
      else url.searchParams.delete('selling_plan');
      window.history.replaceState({}, '', url.toString());
    } catch (e) { dwarn('updateUrlState failed', e); }
  }

  // syncAll runs render() FIRST so any auto-switch (e.g. subscribe→one-time
  // when current variant lacks the plan) happens before syncHiddenInputs
  // reads state. Then sync writes the correct selling_plan + URL state.
  function syncAll() { render(); syncHiddenInputs(); updateUrlState(); }

  // ---------- Init: apply URL state (?variant=X&selling_plan=Y) ----------
  // Mirrors Impulse's native PDP: a shared/refreshed URL restores the user's
  // last selection. Runs BEFORE syncAll() so the initial render sees the
  // correct DOM state. If the URL says Subscribe but the variant doesn't
  // support it, render's auto-switch falls back to OTP and updateUrlState
  // rewrites the URL — clean self-correction.
  function applyUrlState() {
    if (!pdpData) return;
    try {
      const url = new URL(window.location.href);
      const urlVariantId = url.searchParams.get('variant');
      const urlSellingPlan = url.searchParams.get('selling_plan');
      if (urlVariantId && pdpData.variants && pdpData.variants[urlVariantId]) {
        const matchingBtn = root.querySelector('.flavor-btn[data-variant-id="' + urlVariantId + '"]');
        if (matchingBtn && !matchingBtn.classList.contains('on')) {
          flavorBtns.forEach(b => b.classList.remove('on'));
          matchingBtn.classList.add('on');
          const nameEl = matchingBtn.querySelector('.name');
          if (flavorMeta && nameEl) flavorMeta.textContent = nameEl.textContent;
          const flavor = matchingBtn.dataset.flavor;
          const heroForFlavor = root.querySelector('.thumb[data-hero-for-flavor="' + flavor + '"]');
          if (heroForFlavor) selectThumb(heroForFlavor);
        }
      }
      // Only override the default purchase opt if URL is "intentional" (has variant param).
      if (urlVariantId !== null) {
        const wantSub = !!(urlSellingPlan && pdpData.subscribePlanId && String(pdpData.subscribePlanId) === urlSellingPlan);
        const target = wantSub ? subOpt : oneOpt;
        if (target && !target.classList.contains('on')) {
          // Hide ALL radio-inners first (including the default-visible Sub one),
          // then show only the target's. Without this both inners stay visible.
          purchaseOpts.forEach(o => {
            o.classList.remove('on');
            const i = o.querySelector('.radio-inner');
            if (i) i.style.display = 'none';
          });
          target.classList.add('on');
          const inner = target.querySelector('.radio-inner');
          if (inner) inner.style.display = 'block';
        }
      }
    } catch (e) { dwarn('applyUrlState failed', e); }
  }
  applyUrlState();

  // Wire user-state buttons. Each click already triggers render() via the
  // earlier listeners; here we add the form-input sync + URL state.
  syncAll();

  // ---------- Init: sync our purchase-opt UI to Appstle's widget default ----------
  // Appstle merchants configure the default selection (Sub vs OTP) in the
  // Appstle admin. Instead of hardcoding Sub as default in Liquid, we read
  // whichever radio Appstle's widget mounts as "checked" and mirror it.
  // This makes the merchant's Appstle setting authoritative.
  // Skip if URL has explicit state (variant param) — applyUrlState already handled.
  function initFromAppstleWidget() {
    if (!pdpData) return;
    try {
      const u = new URL(window.location.href);
      if (u.searchParams.has('variant')) return;
    } catch (e) {}
    let tries = 0;
    const t = setInterval(() => {
      const checked = document.querySelector(
        '#appstle_subscription_widget0 input[name="selling_plan"]:checked, ' +
        '[id^="shopify-block-"][id*="appstle_subscription"] input[name="selling_plan"]:checked'
      );
      if (checked) {
        clearInterval(t);
        const wantSub = !!checked.value;
        const targetOpt = wantSub ? subOpt : oneOpt;
        if (targetOpt && !targetOpt.classList.contains('on')) {
          purchaseOpts.forEach(o => {
            o.classList.remove('on');
            const i = o.querySelector('.radio-inner');
            if (i) i.style.display = 'none';
          });
          targetOpt.classList.add('on');
          const inner = targetOpt.querySelector('.radio-inner');
          if (inner) inner.style.display = 'block';
          syncAll();
        }
        dlog('initFromAppstleWidget synced to', wantSub ? 'sub' : 'otp');
      } else if (++tries > 50) {
        clearInterval(t);
        dwarn('initFromAppstleWidget: Appstle widget did not mount within 5s');
      }
    }, 100);
  }
  initFromAppstleWidget();
  flavorBtns.forEach(btn => btn.addEventListener('click', syncAll));
  purchaseOpts.forEach(opt => opt.addEventListener('click', syncAll));
  if (qtyMinus) qtyMinus.addEventListener('click', syncAll);
  if (qtyPlus) qtyPlus.addEventListener('click', syncAll);

  dlog('init', { subscribePlanId: pdpData && pdpData.subscribePlanId, variants: pdpData && pdpData.variants && Object.keys(pdpData.variants) });

  // ---------- Canonical Impulse cart-add pattern ----------
  // 1. POST JSON to /cart/add.js (FormData would risk Appstle injecting fields
  //    into our form via its form[action$='/cart/add'] selector — JSON keeps us
  //    in control of what's sent).
  // 2. Dispatch ajaxProduct:added FROM THE FORM with bubbles:true — single
  //    event triggers theme.CartDrawer.buildCart() then open() in Impulse.
  // 3. On error, dispatch ajaxProduct:error so Impulse's inline error display
  //    fires (instead of an alert dialog).
  // 4. In-flight flag prevents duplicate adds from rapid double-clicks.
  // 5. Belt-and-suspenders broadcast for cross-app/theme compatibility
  //    (Appstle Bundles, Klaviyo, GA4 hooks). All idempotent.
  let addInflight = false;

  async function addToCart() {
    if (addInflight) { dlog('add-to-cart blocked — already in flight'); return; }
    if (!pdpData || !addForm) {
      alert('Cart unavailable — please refresh the page.');
      return;
    }
    addInflight = true;
    syncHiddenInputs();
    const atcBtn = document.getElementById('atc-btn');
    const labelEl = atcBtn ? atcBtn.querySelector('.atc-label') : null;
    const originalLabel = labelEl ? labelEl.innerHTML : null;
    const finalBtn = document.getElementById('final-cta-btn');
    const stickyBtn = document.querySelector('.sticky-mobile .sm-btn');
    if (atcBtn) { atcBtn.disabled = true; if (labelEl) labelEl.textContent = 'Adding…'; }
    if (finalBtn) finalBtn.disabled = true;
    if (stickyBtn) stickyBtn.disabled = true;
    try {
      const variantId = parseInt(variantInput.value, 10);
      const quantity = parseInt(quantityInput.value, 10) || 1;
      const sellingPlanRaw = sellingPlanInput.value;
      const sellingPlanId = sellingPlanRaw ? parseInt(sellingPlanRaw, 10) : null;
      const item = { id: variantId, quantity };
      if (sellingPlanId) item.selling_plan = sellingPlanId;
      dlog('add-to-cart payload', { subscribe: getSubscribe(), variantId, sellingPlanId, item });
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [item] })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || err.message || ('HTTP ' + res.status));
      }
      const data = await res.json();
      const product = (data && data.items && data.items[0]) || data;
      // Diagnostic: did selling_plan survive? If we sent one but got no allocation back, Shopify silently dropped it.
      if (sellingPlanId && product && !product.selling_plan_allocation) {
        dwarn('selling_plan was sent but Shopify returned no allocation — variant may not be eligible for the plan');
      }
      dlog('add-to-cart response', product);
      // Canonical Impulse trigger: form-bubbled ajaxProduct:added.
      addForm.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product, addToCartBtn: atcBtn },
        bubbles: true
      }));
      // Cross-theme/app belt-and-suspenders broadcast (idempotent).
      const broadcast = ['cart:build', 'cart:updated', 'cart:update', 'cart:refresh', 'cart:change', 'cart:item-added', 'product:added'];
      broadcast.forEach(name => document.dispatchEvent(new CustomEvent(name, { detail: { product, cart: data } })));
      // Success state — restore quickly, drawer is already opening.
      if (atcBtn && labelEl) {
        labelEl.innerHTML = '✓ Added';
        setTimeout(() => {
          if (originalLabel) labelEl.innerHTML = originalLabel;
          if (atcBtn) atcBtn.disabled = false;
          if (finalBtn) finalBtn.disabled = false;
          if (stickyBtn) stickyBtn.disabled = false;
          addInflight = false;
          render();
        }, 600);
      } else {
        addInflight = false;
        if (finalBtn) finalBtn.disabled = false;
        if (stickyBtn) stickyBtn.disabled = false;
      }
    } catch (e) {
      console.error('[NEKTR PDP] add-to-cart failed:', e);
      // Dispatch Impulse's error event so its inline error UI fires (better
      // than alert()). Keep alert as fallback for themes without the listener.
      if (addForm) {
        addForm.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: { errorMessage: e.message || 'Add to cart failed' },
          bubbles: true
        }));
      }
      if (atcBtn && labelEl) {
        labelEl.innerHTML = originalLabel || 'Add to Bag';
        atcBtn.disabled = false;
      }
      if (finalBtn) finalBtn.disabled = false;
      if (stickyBtn) stickyBtn.disabled = false;
      addInflight = false;
      alert('Could not add to cart: ' + (e.message || 'Unknown error'));
    }
  }

  const atcBtn = document.getElementById('atc-btn');
  if (atcBtn) atcBtn.addEventListener('click', addToCart);

  // ---------- Final CTA + sticky mobile both fire addToCart() directly ----------
  // Previously these only scrolled — labelled "Add to Bag" but didn't add to
  // bag (UX trap). Now they call addToCart() with whatever state is currently
  // selected. If the user wants different state, they can still scroll up.
  const finalCtaBtn = document.getElementById('final-cta-btn');
  if (finalCtaBtn) finalCtaBtn.addEventListener('click', (e) => { e.preventDefault(); addToCart(); });
  const smBtn = document.querySelector('.sticky-mobile .sm-btn');
  if (smBtn) smBtn.addEventListener('click', (e) => { e.preventDefault(); addToCart(); });

  // ---------- Light Labs popup trigger (timing-safe wrapper) ----------
  // window.lightlabs.openModal IS exposed (verified from ll-pip-widget-v5.js),
  // but it's assigned inside a Preact useEffect — only available AFTER the
  // hidden <lightlabs-widget visible="false"> element mounts and its product
  // fetch resolves. If the user clicks before that, poll briefly. After the
  // poll cap, give the user a clear fallback (open the report URL directly).
  // Same URL the LL widget builds internally — including hide_header=1 so the
  // iframe-fallback view matches the native popup chrome-less treatment.
  const LL_REPORT_URL = 'https://app.lightlabs.com/comprehensive-testing-report/510/3371?hide_header=1&external_id=45626986692852';
  // Fallback iframe modal — used when window.lightlabs.openModal never gets exposed
  // (e.g. on a duplicate product whose Shopify variant ID isn't tied to a Light Labs
  // report yet, so the <lightlabs-widget> auto-detect fails and the popup function
  // is never assigned). Renders the report URL in an in-page overlay instead of
  // dumping the user into a new tab.
  function openLightLabsIframeModal() {
    if (document.getElementById('ll-fallback-overlay')) return;
    const overlay = document.createElement('div');
    overlay.id = 'll-fallback-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.85);z-index:2147483646;display:flex;align-items:center;justify-content:center;padding:20px;';
    const modal = document.createElement('div');
    modal.style.cssText = 'position:relative;background:#fff;width:100%;max-width:1100px;height:90vh;max-height:900px;border-radius:8px;overflow:hidden;box-shadow:0 20px 60px rgba(0,0,0,0.4);';
    const closeBtn = document.createElement('button');
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '&times;';
    closeBtn.style.cssText = 'position:absolute;top:10px;right:10px;z-index:10;width:36px;height:36px;border-radius:50%;background:rgba(0,0,0,0.7);color:#fff;border:0;font-size:24px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;font-family:system-ui,sans-serif;';
    const iframe = document.createElement('iframe');
    iframe.src = LL_REPORT_URL;
    iframe.setAttribute('title', 'Light Labs Comprehensive Testing Report');
    iframe.setAttribute('allow', 'fullscreen');
    iframe.style.cssText = 'width:100%;height:100%;border:0;display:block;';
    function close() {
      overlay.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', escHandler);
    }
    function escHandler(ev) { if (ev.key === 'Escape') close(); }
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', (ev) => { if (ev.target === overlay) close(); });
    document.addEventListener('keydown', escHandler);
    modal.appendChild(closeBtn);
    modal.appendChild(iframe);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
  }
  function openLightLabsModal() {
    if (window.lightlabs && typeof window.lightlabs.openModal === 'function') {
      window.lightlabs.openModal();
      return;
    }
    let tries = 0;
    const t = setInterval(() => {
      if (window.lightlabs && typeof window.lightlabs.openModal === 'function') {
        clearInterval(t);
        window.lightlabs.openModal();
      } else if (++tries > 15) {
        // 1.5s cap. The widget's element attributes (product-id + external-id)
        // are hardcoded to the original product, so it should mount in <300ms.
        // If we get here, something's seriously wrong — fall back to iframe.
        clearInterval(t);
        dwarn('Light Labs widget never finished mounting — falling back to in-page iframe modal');
        openLightLabsIframeModal();
      }
    }, 100);
  }

  document.querySelectorAll('[data-ll-popup="true"]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      openLightLabsModal();
    });
  });
  // Reviews CTA — same treatment as the COA box: preventDefault + smooth scroll
  // so #all-reviews never gets stuck in the URL.
  document.querySelectorAll('[data-scroll-target]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const id = el.getAttribute('data-scroll-target');
      const target = root.querySelector('#' + id);
      if (target) {
        const top = target.getBoundingClientRect().top + window.scrollY - 16;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  // Clear any stale section-anchor hash from past navigation so subsequent
  // reloads don't auto-scroll to that section.
  const staleHashes = ['#all-reviews', '#reviews'];
  if (staleHashes.includes(window.location.hash)) {
    history.replaceState(null, '', window.location.pathname + window.location.search);
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

  // ---------- Pattern I gut-wall accordions (HOW NEKTR REINFORCES IT + WHEN IT BREAKS DOWN) ----------
  root.querySelectorAll('.gpi-collapsible .gpi-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const sec = btn.closest('.gpi-collapsible');
      const isOpen = sec.classList.toggle('open');
      btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  // ---------- Hero accordion (with aria-expanded sync) ----------
  const accItems = root.querySelectorAll('.acc-item');
  accItems.forEach(item => {
    const head = item.querySelector('.acc-head');
    head.addEventListener('click', () => {
      const wasOpen = item.classList.contains('open');
      if (wasOpen) item.classList.remove('open');
      else item.classList.add('open');
      head.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
    });
  });

  // ---------- FAQ accordion (with aria-expanded sync) ----------
  const faqItems = root.querySelectorAll('.faq-item');
  faqItems.forEach(item => {
    const q = item.querySelector('.faq-q');
    q.addEventListener('click', () => {
      const isOpen = item.classList.toggle('open');
      q.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  });

  // FAQ expand/collapse all
  const faqExpandAll = root.querySelector('#faq-expand-all');
  if (faqExpandAll) {
    faqExpandAll.addEventListener('click', () => {
      const anyClosed = Array.from(faqItems).some(i => !i.classList.contains('open'));
      faqItems.forEach(i => {
        if (anyClosed) i.classList.add('open');
        else i.classList.remove('open');
        const q = i.querySelector('.faq-q');
        if (q) q.setAttribute('aria-expanded', anyClosed ? 'true' : 'false');
      });
      faqExpandAll.textContent = anyClosed ? 'Collapse all' : 'Expand all';
    });
  }

  // ---------- Stats bar animation ----------
  const barRows = root.querySelectorAll('.bar-row');
  const barObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('inview'); barObs.unobserve(e.target); }
    });
  }, { threshold: 0.4 });
  barRows.forEach(r => barObs.observe(r));

  // ---------- Decay chart animation ----------
  const decayBars = root.querySelector('#decay-bars');
  if (decayBars) {
    const decayObs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { decayBars.classList.add('inview'); decayObs.disconnect(); }
    }, { threshold: 0.4 });
    decayObs.observe(decayBars);
  }

  // ---------- Rating breakdown animation ----------
  const ratingBreakdown = root.querySelector('#rating-breakdown');
  if (ratingBreakdown) {
    const rbObs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { ratingBreakdown.classList.add('inview'); rbObs.disconnect(); }
    }, { threshold: 0.5 });
    rbObs.observe(ratingBreakdown);
  }

  // ---------- Mobile reviews auto-carousel ----------
  const reviewsGrid = root.querySelector('.reviews-grid');
  if (reviewsGrid) {
    let autoScrollTimer = null;
    let userPaused = false;
    function startCarousel() {
      if (!window.matchMedia('(max-width: 900px)').matches) return;
      if (autoScrollTimer) return;
      autoScrollTimer = setInterval(() => {
        if (userPaused) return;
        const card = reviewsGrid.querySelector('.review-card:not(.hidden)');
        if (!card) return;
        const cardWidth = card.getBoundingClientRect().width + 12; // + gap
        const atEnd = reviewsGrid.scrollLeft + reviewsGrid.clientWidth >= reviewsGrid.scrollWidth - 10;
        reviewsGrid.scrollBy({ left: atEnd ? -reviewsGrid.scrollLeft : cardWidth, behavior: 'smooth' });
      }, 3800);
    }
    function stopCarousel() {
      if (autoScrollTimer) { clearInterval(autoScrollTimer); autoScrollTimer = null; }
    }
    // Pause while user interacts; resume on touchend (mobile has no mouseleave)
    reviewsGrid.addEventListener('touchstart', () => { userPaused = true; }, { passive: true });
    reviewsGrid.addEventListener('touchend', () => { setTimeout(() => { userPaused = false; }, 1500); }, { passive: true });
    reviewsGrid.addEventListener('mouseenter', () => { userPaused = true; });
    reviewsGrid.addEventListener('mouseleave', () => { userPaused = false; });
    // Start when carousel enters view
    const carouselObs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) startCarousel(); else stopCarousel();
    }, { threshold: 0.3 });
    carouselObs.observe(reviewsGrid);
    // Restart/stop on resize
    window.addEventListener('resize', () => { stopCarousel(); startCarousel(); });
  }

  // ---------- Ingredient row toggle ----------
  const ingRows = root.querySelectorAll('.ing-row[data-ing]');
  ingRows.forEach(row => {
    row.addEventListener('click', (e) => {
      // Ignore clicks inside drawer content (don't close when reading)
      if (e.target.closest('.ing-drawer-inner')) return;
      row.classList.toggle('open');
    });
  });

  // Gut SVG animations removed in V9.7 Apr-24 client pass — layers render static



  // ---------- Sticky mobile visibility ----------
  const stickyMobile = root.querySelector('.sticky-mobile');
  const hero = root.querySelector('.hero');
  const finalCta = root.querySelector('.final-cta');
  if (stickyMobile && hero && finalCta) {
    const smObs = new IntersectionObserver(() => {
      const heroRect = hero.getBoundingClientRect();
      const ctaRect = finalCta.getBoundingClientRect();
      const pastHero = heroRect.bottom < 0;
      const beforeCta = ctaRect.top > window.innerHeight;
      if (window.matchMedia('(max-width: 900px)').matches) {
        stickyMobile.style.display = (pastHero && beforeCta) ? 'flex' : 'none';
      } else {
        stickyMobile.style.display = 'none';
      }
    }, { threshold: [0, 0.1] });
    smObs.observe(hero);
    smObs.observe(finalCta);
    window.addEventListener('scroll', () => {
      const heroRect = hero.getBoundingClientRect();
      const ctaRect = finalCta.getBoundingClientRect();
      const pastHero = heroRect.bottom < 0;
      const beforeCta = ctaRect.top > window.innerHeight;
      if (window.matchMedia('(max-width: 900px)').matches) {
        stickyMobile.style.display = (pastHero && beforeCta) ? 'flex' : 'none';
      }
    }, { passive: true });
  }


  // Gut-Wall tab auto-cycle removed in V9.7 Apr-24 client pass — all 4 layers now render stacked + static

  // ---------- V9.7 Apr-24 PM: 8-pattern gut-wall switcher ----------
  (function(){
    var btns = root.querySelectorAll('.gps-btn');
    var patterns = root.querySelectorAll('.gut-pattern');
    if (!btns.length || !patterns.length) return;

    var STORAGE_KEY = 'nektr-v97-gut-pattern';
    var DEFAULT = 'I';

    function show(p) {
      btns.forEach(function(b){
        var on = b.getAttribute('data-p') === p;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      patterns.forEach(function(pane){
        var on = pane.getAttribute('data-p') === p;
        pane.hidden = !on;
      });
      try { localStorage.setItem(STORAGE_KEY, p); } catch(e){}
    }

    // Restore saved choice on load
    var saved = DEFAULT;
    try { saved = localStorage.getItem(STORAGE_KEY) || DEFAULT; } catch(e){}
    if (!Array.from(btns).some(function(b){ return b.getAttribute('data-p') === saved; })) {
      saved = DEFAULT;
    }
    show(saved);

    btns.forEach(function(b){
      b.addEventListener('click', function(){ show(b.getAttribute('data-p')); });
    });
  })();

  // ---------- Pattern E: manual tabs (no auto-cycle) ----------
  (function(){
    var tabs = root.querySelectorAll('.gpe-tab');
    var panels = root.querySelectorAll('.gpe-panel');
    if (!tabs.length) return;
    tabs.forEach(function(t){
      t.addEventListener('click', function(){
        var l = t.getAttribute('data-l');
        tabs.forEach(function(x){
          var on = x.getAttribute('data-l') === l;
          x.classList.toggle('active', on);
          x.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function(p){ p.hidden = p.getAttribute('data-l') !== l; });
      });
    });
  })();

  // ---------- Pattern G: scroll-triggered SVG swap (IntersectionObserver) ----------
  (function(){
    var blocks = root.querySelectorAll('.gpg-block');
    var svgs = root.querySelectorAll('.gpg-svg');
    if (!blocks.length || !svgs.length || !('IntersectionObserver' in window)) return;

    function activate(l){
      blocks.forEach(function(b){ b.classList.toggle('active', b.getAttribute('data-l') === l); });
      svgs.forEach(function(s){ s.hidden = s.getAttribute('data-l') !== l; });
    }

    var obs = new IntersectionObserver(function(entries){
      // Pick the topmost currently-intersecting block
      var candidates = entries.filter(function(e){ return e.isIntersecting; });
      if (!candidates.length) return;
      candidates.sort(function(a, b){ return a.boundingClientRect.top - b.boundingClientRect.top; });
      activate(candidates[0].target.getAttribute('data-l'));
    }, { rootMargin: '-30% 0px -45% 0px', threshold: 0.01 });

    blocks.forEach(function(b){ obs.observe(b); });
  })();


  // ---------- V9.7 smooth scroll for all in-page anchor links ----------
  (function(){
    root.querySelectorAll('a[href^="#"]').forEach(function(a){
      a.addEventListener('click', function(e){
        var href = a.getAttribute('href');
        if (!href || href === '#') return;
        var tgt = root.querySelector(href) || document.querySelector(href);
        if (!tgt) return;
        e.preventDefault();
        var y = tgt.getBoundingClientRect().top + window.scrollY - 24;
        window.scrollTo({ top: y, behavior: 'smooth' });
        // Update hash without jumping
        history.replaceState(null, '', href);
      });
    });
  })();


  // ---------- V9.7 Okendo widget loading state + fallback ----------
  (function(){
    var wrapper = root.querySelector('.okendo-widget-wrapper');
    if (!wrapper) return;
    var widget = wrapper.querySelector('[data-oke-widget]');
    var skeleton = wrapper.querySelector('.oke-skeleton');
    if (!widget || !skeleton) return;

    // Watch the widget div — when Okendo populates it with real content, hide skeleton
    var observer = new MutationObserver(function(){
      if (widget.children.length > 0) {
        skeleton.style.display = 'none';
        observer.disconnect();
      }
    });
    observer.observe(widget, { childList: true, subtree: false });

    // Fallback — if no widget content after 8s, show a 'widget unavailable' message
    setTimeout(function(){
      if (widget.children.length === 0) {
        observer.disconnect();
        skeleton.innerHTML = '<div class="oke-sk-fallback"><p><strong>Reviews widget not loaded.</strong></p>' +
          '<p style="font-size: 12.5px; color: rgba(26,26,26,0.6); line-height: 1.55;">' +
          'Confirm the Okendo subscriber ID is set in the <code>&lt;head&gt;</code> and that the Okendo Reviews app is installed on your Shopify store.' +
          '</p><p><a href="#reviews" style="color: var(--teal); font-weight: 600; text-decoration: underline;">Read all 430+ reviews &rarr;</a></p></div>';
        skeleton.style.textAlign = 'center';
      }
    }, 8000);
  })();

  // ---------- V9.7 Comparison accordion rows ----------
  (function(){
    var toggles = root.querySelectorAll('.cv2-toggle');
    toggles.forEach(function(btn){
      btn.addEventListener('click', function(){
        var row = btn.closest('.comp-v2-row');
        if (!row) return;
        var detail = row.querySelector('.comp-v2-detail');
        var isOpen = row.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          row.setAttribute('aria-expanded', 'false');
          btn.setAttribute('aria-expanded', 'false');
          if (detail) detail.hidden = true;
        } else {
          row.setAttribute('aria-expanded', 'true');
          btn.setAttribute('aria-expanded', 'true');
          if (detail) detail.hidden = false;
        }
      });
    });
  })();

})();
